import { RootState } from '../models';
import { selectEvaluatedTemplate } from './selectEvaluatedTemplate';

export const selectPosterSrc = (state: RootState): string | undefined => {
  const template = selectEvaluatedTemplate(state);
  if(template) {
    return template.poster;
  }
};